import UsersInfoTable from "../UsersSummaryTable/UsersInfoTable";

export default function UserInfo() {

    return (
        <>
            <UsersInfoTable />
        </>
    )
}